

export class RequestDetail {
    private _model : any;
    constructor(private _modelDefined: any) {
        this._model = this._modelDefined ? angular.copy(this._modelDefined) : {};
    }

    // Consignee Details
    get consigneeName1(): string {
        return this._model.consigneeName1;
    }

    set consigneeName1(val: string) {
        this._model.consigneeName1 = val;
    }

    get consigneeName2(): string {
        return this._model.consigneeName2;
    }

    set consigneeName2(val: string) {
        this._model.consigneeName2 = val;
    }

    get consigneeName3(): string {
        return this._model.consigneeName3;
    }

    set consigneeName3(val: string) {
        this._model.consigneeName3 = val;
    }

    get consigneeName(): string {
        return this._model.consigneeName;
    }

    set consigneeName(val: string) {
        this._model.consigneeName = val;
    }

    get consigneeName4(): string {
        return this._model.consigneeName4;
    }

    set consigneeName4(val: string) {
        this._model.consigneeName4 = val;
    }

    get consigneeStreet1(): string {
        return this._model.consigneeStreet1;
    }

    set consigneeStreet1(val: string) {
        this._model.consigneeStreet1 = val;
    }

    get consigneeStreet2(): string {
        return this._model.consigneeStreet2;
    }

    set consigneeStreet2(val: string) {
        this._model.consigneeStreet2 = val;
    }

    get consigneeStreet3(): string {
        return this._model.consigneeStreet3;
    }

    set consigneeStreet3(val: string) {
        this._model.consigneeStreet3 = val;
    }

    get consigneeStreet4(): string {
        return this._model.consigneeStreet4;
    }

    set consigneeStreet4(val: string) {
        this._model.consigneeStreet4 = val;
    }

    get consigneeHouseNumber(): string {
        return this._model.consigneeHouseNumber;
    }

    set consigneeHouseNumber(val: string) {
        this._model.consigneeHouseNumber = val;
    }

    get consigneePostalCode(): string {
        return this._model.consigneePostalCode;
    }

    set consigneePostalCode(val: string) {
        this._model.consigneePostalCode = val;
    }

    get consigneeRegion(): string {
        return this._model.consigneeRegion;
    }

    set consigneeRegion(val: string) {
        this._model.consigneeRegion = val;
    }

    get transportMode(): string {
        return this._model.transportMode;
    }

    set transportMode(val: string) {
        this._model.transportMode = val;
    }

    get consigneeStreet1AndHouseNumber(): string {
        return this.consigneeStreet1 +
            " " +
            ((this.consigneeHouseNumber !== undefined && this.consigneeHouseNumber !== null)
                ? this.consigneeHouseNumber
                : "");
    }

    get consigneeCity(): string {
        return this._model.consigneeCity;
    }

    set consigneeCity(val: string) {
        this._model.consigneeCity = val;
    }

get consigneeCityAndRegion(): string {
        
        return this.consigneeCity +
            (this.consigneeRegion !== undefined && this.consigneeRegion !== null && this.consigneeRegion.length > 0 ? ", " + this.consigneeRegion : "");
    }

    get consigneePostalCodeAndCountry(): string {
        return this.consigneePostalCode + " " + this.consigneeCountry;
}

    get consigneeCountry(): string {
        return this._model.consigneeCountry;
    }

    set consigneeCountry(val: string) {
        this._model.consigneeCountry = val;
    }

    //Shipment Detail
    get additionalInstruction(): string {
        return this._model.additionalInstruction;
    }

    set additionalInstruction(val: string) {
        this._model.additionalInstruction = val;
    }

    get additionalFreightCharges(): string {
        return this._model.additionalFreightCharges !== null ? "$" + this._model.additionalFreightCharges : undefined;
    }

    set additionalFreightCharges(val: string) {
        this._model.additionalFreightCharges = val;
    }

    get additionalPackagingFees(): string {
        return this._model.additionalPackagingFees !== null ? "$" + this._model.additionalPackagingFees : undefined;
    }

    set additionalPackagingFees(val: string) {
        this._model.additionalPackagingFees = val;
    }

   get requestCreatedBy(): string {
       return this._model.requestCreatedBy;
    }

    set requestCreatedBy(val: string) {
       this._model.requestCreatedBy = val;
   }
    
   get requestCreatedDate(): string {
       if (this._model.requestCreatedDate != undefined) {
           return this.getFormattedDateWithAmpm(new Date(this._model.requestCreatedDate));
       }
       return undefined;
    }

   get isShowUserDetails(): boolean {
        return this._model.isShowUserDetails;
   }

   set isShowUserDetails(val: boolean) {
       this._model.isShowUserDetails = val;
   }

    get chargeToConsignee(): string  {
        
        if (this._model.chargeToConsignee !== undefined && this._model.chargeToConsignee === true) {
            return "Yes";
        }
        return "No";
    }

    set chargeToConsignee(val: string) {
        if (val !== undefined && val === "Yes") {
            this._model.chargeToConsignee = true;
        }
        this._model.chargeToConsignee = false;
    }

    get isAsset(): string {
        if (this._model.isAsset !== undefined && this._model.isAsset === true) {
            return "Yes";
        }
        return "No";
    }

    set isAsset(val: string) {
        if (val !== undefined && val === "Yes") {
            this._model.isAsset = true;
        }
        this._model.isAsset = false;

    }
    get isFAMR(): string {
        if (this._model.isFAMR !== undefined && this._model.isFAMR === true) {
            return "Yes";
        }
        return "No";
    }

    set isFAMR(val: string) {
        if (val !== undefined && val === "Yes") {
            this._model.isFAMR = true;
        }
        this._model.isFAMR = false;

    }

    

    get requestedDeliveryDate(): string {
        if (this._model.requestedDeliveryDate != undefined) {
            return this.getFormattedDate(new Date(this._model.requestedDeliveryDate));
        }
        return undefined;
    }

    set requestedDeliveryDate(val: string) {
        this._model.requestedDeliveryDate = val;
    }

    private getFormattedDate(dateValuetobeFormatted: Date): string {
        var monthValue = dateValuetobeFormatted.getMonth() + 1;
        var dateValue = dateValuetobeFormatted.getDate();
        var yearValue = dateValuetobeFormatted.getFullYear();
        return monthValue + "/" + dateValue + "/" + yearValue;
    }

    /// Datetime Formate in dd/mm/yyyy HH:MM AM
    private getFormattedDateWithAmpm(dateValuetobeFormatted: Date): string {
        var monthValue = dateValuetobeFormatted.getMonth() + 1;
        var dateValue = dateValuetobeFormatted.getDate();
        var yearValue = dateValuetobeFormatted.getFullYear();
        var hourValue = dateValuetobeFormatted.getHours();
        var minValue = dateValuetobeFormatted.getMinutes();
        var secValue = dateValuetobeFormatted.getSeconds();
        var ampm = hourValue >= 12 ? 'PM' : 'AM';
        hourValue = hourValue % 12;
        hourValue = hourValue ? hourValue : 12;
        return monthValue + "/" + dateValue + "/" + yearValue + " " + this.leftPad(hourValue, 2) + ":" + this.leftPad(minValue,2)
            + " " + ampm;
    }

   private leftPad(num: number, size: number): string {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    // PickupLoaction Details
    get location(): string {
        return this._model.location;
    }

    set location(val: string) {
        this._model.location = val;
    }

    get contactName(): string {
        return this._model.contactName;
    }

    set contactName(val: string) {
        this._model.contactName = val;
    }

    get companyName(): string {
        return this._model.companyName;

    }

    set companyName(val: string) {
        this._model.companyName = val;
    }


    get pickupLoactionAddressLine1(): string {
        return this._model.pickupLoactionAddressLine1;
    }

    set pickupLoactionAddressLine1(val: string) {
        this._model.pickupLoactionAddressLine1 = val;
    }
    

    get pickupLoactionAddressLine2(): string {
        return this._model.pickupLoactionAddressLine2;
    }

    set pickupLoactionAddressLine2(val: string) {
        this._model.pickupLoactionAddressLine2 = val;
    }

    get pickupLoactionCity(): string {
        return this._model.pickupLoactionCity;
    }

    set pickupLoactionCity(val: string) {
        this._model.pickupLoactionCity = val;
    }

    get pickupLoactionRegionCode(): string {
        return this._model.pickupLoactionRegionCode;
    }

    set pickupLoactionRegionCode(val: string) {
        this._model.pickupLoactionRegionCode = val;
    }

    get pickupLoactionPostalCode(): string {
        return this._model.pickupLoactionPostalCode;
    }
    
    set pickupLoactionPostalCode(val: string) {
        this._model.pickupLoactionPostalCode = val;
    }

    get pickupLoactionCityRegionCodeAndPostalCode(): string {
        return this.pickupLoactionCity + ", " + this.pickupLoactionRegionCode + " " + this.pickupLoactionPostalCode;
    }

    get phoneNumber(): string {
        return this._model.phoneNumber;
    }
    
    set phoneNumber(val: string) {
        this._model.phoneNumber = val;
    }

    get shipmentReadyDate(): string {
        if (this._model.shipmentReadyDate != undefined) {
            return this.getFormattedDate(new Date(this._model.shipmentReadyDate));
        }
        return undefined;
    }

    set shipmentReadyDate(val: string) {
        this._model.shipmentReadyDate = val;
    }

    get shipmentContactName(): string {
        return this._model.shipmentContactName;
    }

    set shipmentContactName(val: string) {
        this._model.shipmentContactName = val;
    }

    get shipmentContactPhoneNumber(): string {
        return this._model.shipmentContactPhoneNumber;
    }

    set shipmentContactPhoneNumber(val: string) {
        this._model.shipmentContactPhoneNumber = val;
    }

    get generalLedger(): string {
        return this._model.generalLedger;
    }

    set generalLedger(val: string) {
        this._model.generalLedger = val;
    }

    get costCenter(): string {
        return this._model.costCenter;
    }

    set costCenter(val: string) {
        this._model.costCenter = val;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/models/requestDetail.ts
 **/